import { Constants } from './Constants';
import { Util } from './Util';

export class SettingsCheck {
	public static isStandaloneModeActive(): boolean {
		if (this.isStandaloneModeParamDefined()) {
			// Only read value if explicitly defined
			return this.isStandaloneModeParamActive();
		}
		// Only read value if URL param not defined and global variable explicitly defined
		return this.isStandaloneModeGlobalDefinedAndActive();
	}

	public static isStandaloneModeParamDefined(): boolean {
		return Util.isUrlParamDefined(Constants.URL_PARAM_STANDALONE_MODE);
	}

	public static isStandaloneModeParamActive(): boolean {
		return Util.isUrlParamActive(Constants.URL_PARAM_STANDALONE_MODE, 'true');
	}

	public static isStandaloneModeGlobalDefinedAndActive(): boolean {
		Util.ensureGlobalContext('pxdata', 'settings');
		const _window: Window = window;
		if (_window.sap.pxdata.settings.standalone && _window.sap.pxdata.settings.standalone === true) {
			return true;
		}
		return false;
	}
}
